<template>
  <div class="table-responsive">
    <table>
      <thead class="thead-gray">
        <tr class="text-center">
          <th scope="col" class="text-uppercase" v-for="(item, index) in dataHead" :key="index">
            {{ item }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr class="table-row" v-for="(itemRow, index) in dataRow" :key="index">
          <td v-for="(item, index) in itemRow" :key="index">{{ item }}</td>
        </tr>
        <tr class="table-row text-center">
          <td colspan="3" class="p-3">Chi nhánh thứ 02 giảm 10% trên giá niêm yết</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  export default {
    props: {
      dataTable: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        dataHead: [],
        dataRow: [],
      }
    },
    mounted() {
      this.dataHead = this.dataTable.column
      this.dataRow = this.dataTable.rows
    },
  }
</script>

<style scoped></style>
